import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  CustomInput,
} from "reactstrap";
import AppContext from "./../../context/Context";
import { Logout, userIsFetching } from "../../actions/authActions";
import { checkUserToken } from "../../helpers/api/auth";
import Avatar from "../common/Avatar";
import { UnselectProperty } from "../../actions/propertyActions";
import { UnselectCondominium } from "../../actions/condominiumActions";

const ProfileDropdown = () => {
  const { isDark, setIsDark } = useContext(AppContext);
  const { setUser } = useContext(AppContext);

  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(Logout());
  };
  const { role, token, hasMultipleProperties } = useSelector(
    (state) => state.auth.user
  );
  const { isFetching } = useSelector((state) => state.auth);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [update, setUpdate] = useState(0);

  const handleChangeProperty = () => {
    dispatch(UnselectProperty());
    dispatch(UnselectCondominium());
  };

  const [profile, setProfile] = useState({
    data: null,
    error: null,
    isLoading: true,
  });

  const { data, isLoading } = profile;

  useEffect(() => {
    if (isFetching) {
      if (isFetching.profilePicture) {
        dispatch(userIsFetching({ profilePicture: false }));
      }
      if (!isFetching.profilePicture) {
        setUpdate(update + 1);
      }
    }
    // eslint-disable-next-line
  }, [isFetching]);

  useEffect(() => {
    let isMounted = true;
    if (token) {
      const getProfile = async () => {
        try {
          const { data } = await checkUserToken(token);
          if (isMounted) {
            setProfile((prev) => {
              return { ...prev, data, isLoading: false };
            });
            setUser(data);
          }
        } catch (e) {
          if (isMounted) {
            setProfile((prev) => {
              return { ...prev, error: e, isLoading: false };
            });
          }
        }
      };
      getProfile();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [update]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <Dropdown
      nav
      inNavbar
      isOpen={dropdownOpen}
      toggle={toggle}
      onMouseOver={() => {
        const windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(true);
      }}
      onMouseLeave={() => {
        const windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(false);
      }}
    >
      <DropdownToggle nav className="pr-0">
        <Avatar
          src={isLoading ? null : data?.image ? `${data.image}` : null}
          name={
            isLoading
              ? role === "manager"
                ? "Administrador"
                : role === "property"
                  ? "Propietario"
                  : role === "safety"
                    ? "Vigilante"
                    : role === "root"
                      ? "Root"
                      : data?.firstname
              : data?.firstname
          }
          className={isLoading ? "spinner-grow" : ""}
        />
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-card">
        <div className="bg-white rounded-soft py-2">
          <DropdownItem tag={Link} to={`/dashboard/my/profile`}>
            Perfil y cuenta
          </DropdownItem>
          {selectedCondominium && role === "manager" && (
            <DropdownItem tag={Link} to="/dashboard/config">
              Configuración
            </DropdownItem>
          )}
          {role === "property" && hasMultipleProperties && (
            <DropdownItem
              tag={Link}
              to="/dashboard/app"
              onClick={handleChangeProperty}
            >
              Cambiar de propiedad
            </DropdownItem>
          )}

          <DropdownItem className="d-flex align-items-center">
            Modo oscuro
            <CustomInput
              style={{ cursor: "pointer" }}
              className="ml-2"
              type="switch"
              id="rtl-switch"
              checked={isDark}
              onChange={({ target }) => setIsDark(target.checked)}
            />
          </DropdownItem>
          {role === "manager" && (
            <DropdownItem
              className="d-flex align-items-center"
              tag={Link}
              to="/dashboard/currency"
            >
              Configuración de moneda
            </DropdownItem>
          )}

          <DropdownItem divider />

          <DropdownItem onClick={handleLogout}>Cerrar sesión</DropdownItem>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
